document.addEventListener(`DOMContentLoaded`, function () {
  var swiperTabsSlider = new Swiper(`.cl-navigation-${sectionId} .cl-navigation__bottom-slider`, {
    centeredSlides: false,
    watchOverflow: true,
    loop: false,
    slidesPerGroup: 1,
    preventClicks: true,
    breakpoints: {
      0: {
        slidesPerView: 1.2,
        spaceBetween: 12,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 16,
      },
    },
  });
  const anchors = document.querySelectorAll(`.cl-navigation .cl-navigation-nav__item`);
  const imgAnchors = document.querySelectorAll(`.cl-navigation .cl-navigation-content__item`);
  const container = document.querySelector(`.cl-navigation-${sectionId} .cl-navigation__top`);
  const sections = document.querySelectorAll(`[data-section-id]`);
  const clContainer = document.querySelector(`.cl-navigation-${sectionId}`);
  const paddingTop = window.getComputedStyle(clContainer).paddingTop;
  const position = window.getComputedStyle(container).position;
  const subtitles = document.querySelectorAll(`.cl-navigation-${sectionId} .cl-navigation__subtitle`);
  function switchSubtitle (navIndex) {
    subtitles.forEach(function (sub) {
      const match = sub.dataset.navIndex === String(navIndex);
      sub.style.display = match ? `block` : `none`;
      sub.classList.toggle(`active`, match);
    });
  }
  anchors.forEach((anchor) => {
    anchor.addEventListener(`click`, function (event) {
      event.preventDefault();
      const targetDataId = this.getAttribute(`data-target`);
      const targetSection = document.querySelector(`[data-section-id="${targetDataId}"]`);
      const navIndex = this.dataset.navIndex;
      if (navIndex !== undefined) {
        switchSubtitle(navIndex);
      }
      if (!container.classList.contains(`fixed`)) {
        const tabIndex = anchor.dataset.tabStartIndex;
        const tabEndIndex = anchor.dataset.tabEndIndex;
        if (tabIndex > 0) {
          anchors.forEach(a => a.classList.remove(`active`));
          this.classList.add(`active`);
          swiperTabsSlider.slideTo(tabIndex - 1);
          imgAnchors.forEach(a => a.classList.remove(`highlight`));
          imgAnchors.forEach((img, index) => {
            if (index >= (tabIndex - 1) && index <= (tabEndIndex - 1)) {
              img.classList.add("highlight");
            }
          });
          return;
        }
      }
      if (targetSection) {
        let navHeight = container.offsetHeight || 0;
        if (!container.classList.contains(`fixed`)) {
          navHeight = navHeight + 88;
        }
        const targetPosition = targetSection.getBoundingClientRect().top + window.scrollY - navHeight;
        window.scrollTo({
          top: targetPosition,
          behavior: `smooth`
        });
        anchors.forEach(a => a.classList.remove(`active`));
        this.classList.add(`active`);
      }
    });
  });
  if (anchors[0]) {
    anchors[0].click();
  }
  imgAnchors.forEach((imgAnchor) => {
    imgAnchor.addEventListener(`click`, function (event) {
      event.preventDefault();
      const imgtargetDataId = this.getAttribute(`data-target`);
      const imgtargetSection = document.querySelector(`[data-section-id="${imgtargetDataId}"]`);
      if (imgtargetSection) {
        let navHeight = container.offsetHeight || 0;
        if (!container.classList.contains(`fixed`)) {
          navHeight = navHeight + 88;
        }
        const targetPosition = imgtargetSection.getBoundingClientRect().top + window.scrollY - navHeight;
        window.scrollTo({
          top: targetPosition,
          behavior: `smooth`
        });
      }
    });
  });
  function handleScroll () {
    const clNavigation = document.querySelector(`.cl-navigation`);
    const scrollY = window.scrollY;
    const navHeight = container.offsetHeight || 0;
    let currentSection = null;
    for (const temp of sections) {
      const section = temp.closest(".shopify-section");
      const sectionTop = section.offsetTop - navHeight;
      const sectionBottom = sectionTop + section.offsetHeight;
      if (scrollY >= sectionTop && scrollY < sectionBottom) {
        currentSection = temp;
        break;
      }
    }
    anchors.forEach((anchor) => {
      const targetDataId = anchor.getAttribute(`data-target`);
      if (currentSection) {
        const sectionDataId = currentSection.getAttribute(`data-section-id`);
        const shouldBeActive = targetDataId === sectionDataId;
        anchor.classList.toggle(`active`, shouldBeActive);
        if (shouldBeActive) {
          const navIndex = anchor.dataset.navIndex;
          if (navIndex !== undefined) {
            switchSubtitle(navIndex);
          }
        }
      }
    });
    const containerStart = container.dataset.startTop || container.offsetTop;
    if (scrollY > containerStart) {
      container.classList.add(`fixed`);
    } else {
      container.classList.remove(`fixed`);
    }
  }
  container.dataset.startTop = container.offsetTop;
  window.addEventListener(`scroll`, handleScroll);
  window.addEventListener(`scroll`, imageScroll);
  handleScroll();
  imageScroll();
});
